var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWorkspaceBankingcomponent = function SvgWorkspaceBankingcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5 6h-24a2.977 2.977 0 0 0-2.985 3L3.5 27c0 1.665 1.335 3 3 3h24c1.665 0 3-1.335 3-3V9c0-1.665-1.335-3-3-3Zm0 21h-24v-9h24v9Zm-24-15h24V9h-24v3Z",
    fill: "#FC5F6B"
  })));
};
export default SvgWorkspaceBankingcomponent;